import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-forest-900 text-center text-cream" aria-label="Limited time offer" data-id="element-272" data-mp="369pga49jt16e">
      <div className="h-1.5 w-full bg-gold-500" aria-hidden="true" data-id="element-273" data-mp="31j8zqbafkzft" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-274" data-mp="31hxvkad2ppo6">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.16em] text-gold-400" data-id="element-275" data-mp="3g7c81rby4n7s">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-276" data-mp="3b89306vyugzt" /> Launch pricing ends in
        </p>
        <Countdown className="mt-5" data-id="element-277" data-mp="3p7il5c3qfl6f" />
        <p className="mt-7 font-bold text-forest-100" data-id="element-278" data-mp="3p6h5svfoociw">After that the price increases and never drops again.</p>

        <div className="mx-auto mt-6 max-w-xl rounded-lg border border-cream/10 bg-forest-800 p-4 text-sm" data-id="element-279" data-mp="1uusqut9gc9yi">
          <p className="font-bold text-cream" data-id="element-280" data-mp="1qtgw69bq0yjg">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-gold-400" data-id="element-281" data-mp="1qurzy95626ak" />
            Remaining launch pricing spots: limited
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-forest-900" data-id="element-282" data-mp="2xrzkk7i2vjy9">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full rounded-full bg-gold-500" data-id="element-283" data-mp="32s3zvu7928mw" />
          </div>
          <p className="mt-1 text-right text-xs text-forest-100" data-id="element-284" data-mp="3gipn1v3ql4ql">66% of spots taken</p>
        </div>
      </div>
      <div className="h-1.5 w-full bg-earth-500" aria-hidden="true" data-id="element-285" data-mp="3li27yab1s1qj" />
    </section>;
}